{
  "el": {
    "activemodel": {
      "errors": {
        "models": {
          "temporary/booking_form": {
            "attributes": {
              "adults": {
                "blank": "Συμπληρώστε τον αριθμό των ενηλίκων επισκεπτών.",
                "greater_than_or_equal_to": "Απαιτείται ένας τουλάχιστον ενήλικος."
              },
              "arrival": {
                "blank": "Πότε φτάνετε; Επιλέξτε στο ημερολόγιο.",
                "invalid_date": "Πότε φτάνετε; Επιλέξτε στο ημερολόγιο.",
                "on_or_after": "Είστε ταξιδιώτης στο χρόνο; Δεν μπορείς να φτάσεις χθες 🤔"
              },
              "babies": {
                "blank": "Συμπληρώστε τον αριθμό των βρεφών. Το ελάχιστο είναι μηδέν.",
                "greater_than_or_equal_to": "Όχι, δεν μπορείτε να πάρετε και τα δικά μας βρέφη! Το ελάχιστο είναι μηδέν."
              },
              "children": {
                "blank": "Συμπληρώστε τον αριθμό των παιδιών. Το ελάχιστο είναι μηδέν.",
                "greater_than_or_equal_to": "Όχι, δεν μπορείτε να πάρετε και τα δικά μας παιδιά! Το ελάχιστο είναι μηδέν."
              },
              "country": {
                "blank": "Απαιτείται ο κωδικός χώρας του τηλεφώνου."
              },
              "departure": {
                "after": "Θέλετε να φύγετε πριν καν φτάσετε; 🤯",
                "blank": "Πότε αναχωρείτε; Επιλέξτε στο ημερολόγιο.",
                "invalid_date": "Πότε αναχωρείτε; Επιλέξτε στο ημερολόγιο."
              },
              "email": {
                "blank": "Χρειαζόμαστε το E-Mail σας για να απαντήσουμε στο αίτημά σας.",
                "invalid": "Αυτό το E-Mail δεν φαίνεται σωστό. Παρακαλούμε ελέγξτε το."
              },
              "first_name": {
                "blank": "Χρειάζεται να γνωρίζουμε το όνομά σας, πώς να σας αποκαλούμε;"
              },
              "language": {
                "blank": "Η γλώσσα πρέπει να καθοριστεί"
              },
              "last_name": {
                "blank": "Χρειάζεται να γνωρίζουμε το επώνυμό σας για την περίπτωση που κάποιος άλλος έχει το ίδιο όνομα με εσάς."
              },
              "mature_guests": {
                "blank": "Πόσοι επισκέπτες;",
                "greater_than_or_equal_to": "Πρέπει να υπάρχει τουλάχιστον ένα άτομο."
              },
              "message": {
                "too_long": {
                  "one": "Εξαντλήσατε τον διαθέσιμο χώρο (1 χαρακτήρας).",
                  "other": "Εξαντλήσατε τον διαθέσιμο χώρο (%{count} χαρακτήρες)."
                }
              },
              "mobile": {
                "invalid": "Χρειαζόμαστε τον αριθμό του κινητού σας, για να επικοινωνήσουμε μαζί σας.",
                "length": "Ο αριθμός που καταχωρίσατε δεν είναι έγκυρος.",
                "max_length": "Ο αριθμός που καταχωρίσατε έχει περισσότερα ψηφία για την περιοχή αυτή.",
                "min_length": "Ο αριθμός που καταχωρίσατε έχει πολύ λίγα ψηφία για την περιοχή αυτή.",
                "mobile": "Ο αριθμός που καταχωρίσατε δεν είναι ενός κινητού.",
                "not_local": "Ο αριθμός που καταχωρίσατε είναι ελλιπής. Παρακαλούμε βεβαιωθείτε ότι συμπληρώσατε και τον κωδικό της περιοχής.",
                "valid_country": "Ο αριθμός που καταχωρίσατε δεν έχει έγκυρο Κωδικό Χώρας."
              },
              "nights": {
                "blank": "Πόσες νύχτες θα μείνετε; Επιλέξτε στο ημερολόγιο."
              },
              "recaptcha": {
                "blank": "Απαιτείται το Recaptcha"
              },
              "recaptcha_incorrect": {
                "blank": "Το Recaptcha είναι λάθος"
              },
              "terms": {
                "accepted": "Θα πρέπει να συμφωνήσετε με τους όρους κράτησης πριν αποστείλετε το αίτημά σας.",
                "blank": "Θα πρέπει να συμφωνήσετε με τους όρους κράτησης πριν αποστείλετε το αίτημά σας."
              }
            }
          }
        }
      }
    }
  },
  "en": {
    "activemodel": {
      "errors": {
        "models": {
          "temporary/booking_form": {
            "attributes": {
              "adults": {
                "blank": "How many adults?",
                "greater_than_or_equal_to": "There needs to be at least one adult."
              },
              "arrival": {
                "blank": "When will you arrive? (Use the calendar)",
                "invalid_date": "When will you arrive? (Use the calendar)",
                "on_or_after": "Are you a time traveler? You can't arrive yesterday 🤔"
              },
              "babies": {
                "blank": "How many babies? The minimum is zero.",
                "greater_than_or_equal_to": "No, you may not take our babies! The minimum is zero."
              },
              "children": {
                "blank": "How many children? The minimum is zero.",
                "greater_than_or_equal_to": "No, you may not take our children! The minimum is zero."
              },
              "country": {
                "blank": "Phone country code is required."
              },
              "departure": {
                "after": "So you want to depart before you even arrive? 🤯",
                "blank": "When will you depart? (Use the calendar)",
                "invalid_date": "When will you depart? (Use the calendar)"
              },
              "email": {
                "blank": "We need your email address so we can reply to your request.",
                "invalid": "This email address doesn't seem correct. Please check it."
              },
              "first_name": {
                "blank": "We need to know your name, what should we call you?"
              },
              "language": {
                "blank": "Language must be specified"
              },
              "last_name": {
                "blank": "We need to know your last name (family name/surname) in case someone has the same first name as you."
              },
              "mature_guests": {
                "blank": "How many guests?",
                "greater_than_or_equal_to": "There needs to be at least one person."
              },
              "message": {
                "too_long": {
                  "one": "Maximum limit reached (1 character).",
                  "other": "Maximum limit reached (%{count} characters)."
                }
              },
              "mobile": {
                "invalid": "We need your mobile number to communicate with you.",
                "length": "The number you entered is invalid.",
                "max_length": "The number you entered is too long for this region.",
                "min_length": "The number you entered is too short for this region.",
                "mobile": "The number you entered is not a mobile number. Please check it.",
                "not_local": "The number you entered is incomplete. Make sure to include your area code.",
                "valid_country": "The number you entered has an invalid country calling code."
              },
              "nights": {
                "blank": "How many nights? (Use the calendar)"
              },
              "recaptcha": {
                "blank": "Recaptcha is required"
              },
              "recaptcha_incorrect": {
                "blank": "Captcha is incorrect"
              },
              "terms": {
                "accepted": "You must agree to our terms before making a booking request.",
                "blank": "You must agree to our terms before making a booking request."
              }
            }
          }
        }
      }
    }
  }
}